// Header bubbles

let count = 100;
let headerSection = document.querySelector('#bubbles');
let bubbleCount = 0;

while (bubbleCount < count) {
    let bubble = document.createElement('div');
    bubble.classList.add('bubblesItem');
    let x = Math.floor(Math.random() * window.innerWidth);
    let y = Math.floor(Math.random() * window.innerHeight);
    let size = Math.random() * 10;

    bubble.style.left = `${x}px`;
    bubble.style.top = `${y}px`;
    bubble.style.height = `${10 + size}px`;
    bubble.style.width = `${10 + size}px`;

    bubble.style.animationDuration = `${5 + size}s`;
    bubble.style.animationDelay = `${-size}s`;

    headerSection.appendChild(bubble);
    bubbleCount++;
}
